document.addEventListener('DOMContentLoaded', function () {
  var money = function (c) { return (c / 100).toLocaleString('fr-FR', { style: 'currency', currency: window.shopCurrency || 'EUR' }); };

  var main = document.querySelector('[data-main]');
  document.querySelectorAll('[data-thumb]').forEach(function (b) {
    b.addEventListener('click', function () {
      if (!main) return;
      main.removeAttribute('srcset'); main.src = b.dataset.thumb;
      document.querySelectorAll('[data-thumb]').forEach(function (x) { x.setAttribute('aria-current', 'false'); });
      b.setAttribute('aria-current', 'true');
    });
  });

  var json = document.querySelector('[data-variants]');
  if (json) {
    var variants = JSON.parse(json.textContent);
    var sets = Array.prototype.slice.call(document.querySelectorAll('[data-option]'));
    var add = document.querySelector('[data-add]');
    var available = function (vals) { return variants.some(function (v) { return v.options.every(function (o, i) { return o === vals[i]; }); }); };
    var refresh = function () {
      var vals = sets.map(function (f) { var c = f.querySelector('input:checked'); return c ? c.value : null; });
      sets.forEach(function (f, i) {
        var lab = f.querySelector('[data-option-value]'); if (lab) lab.textContent = vals[i] || '';
        f.querySelectorAll('input').forEach(function (inp) {
          var test = vals.slice(); test[i] = inp.value;
          inp.closest('.pill').classList.toggle('pill--na', !available(test));
        });
      });
      var v = variants.find(function (x) { return x.options.every(function (o, i) { return o === vals[i]; }); });
      if (!v) { add.disabled = true; add.textContent = 'Configuration indisponible'; return; }
      document.querySelector('[data-variant-id]').value = v.id;
      var p = document.querySelector('.pdp__price [data-price-amount]'); if (p) p.textContent = money(v.price);
      var t = document.querySelector('[data-ttc]'); if (t) t.textContent = money(Math.round(v.price * 1.2));
      var s = document.querySelector('[data-sku]'); if (s) s.textContent = v.sku || '—';
      var st = document.querySelector('.pdp__meta [data-stock]');
      if (st) { st.textContent = v.available ? 'En stock' : 'Sur commande'; st.classList.toggle('stock--off', !v.available); }
      add.disabled = !v.available;
      add.textContent = v.available ? 'Ajouter au panier' : 'Indisponible';
      if (v.featured_image && main) { main.removeAttribute('srcset'); main.src = v.featured_image.src; }
      history.replaceState(null, '', '?variant=' + v.id);
    };
    sets.forEach(function (f) { f.addEventListener('change', refresh); });
    if (sets.length) refresh();
  }

  document.querySelectorAll('[data-autosubmit]').forEach(function (f) { f.addEventListener('change', function () { f.submit(); }); });

  // close other dropdowns
  document.querySelectorAll('.dd').forEach(function (d) {
    d.addEventListener('toggle', function () { if (d.open) document.querySelectorAll('.dd').forEach(function (o) { if (o !== d) o.open = false; }); });
  });

  var q = new URLSearchParams(location.search).get('produit');
  var f = document.querySelector('[data-prefill]'); if (q && f) f.value = q;
});
